/**
 * Inline JavaScript for the Growl component.
 * This script is injected via dangerouslySetInnerHTML and will be
 * processed by Zephr to replace template variables like {{...}}.
 * TODO: Re-implement as javascript and import raw string into component
 */
export const growlScript = `
  <script>
    const { outcomeId, outcomeLabel } = Zephr.outcomes["{{analytics-rule-name}}"] || {};
    let experimentGroups;

    // helper function used to build DL events
    const buildEcommerce = (slot = "baby growl") => {
        // temporary solution to use split tests for variant meters, update for generalized split test data collection
        experimentGroups = getExperimentGroups();

        return {
          creative_name: "{{body-text}}",
          creative_slot: slot,
          promotion_id: outcomeLabel,
          promotion_name: "Baby Growl",
          items: [{
              zephr_canvas_id: outcomeId,
              experiment_groups: experimentGroups
          }]
        }
    };

    const getExperimentGroups = () => {
        let brandLetter;

        const zephrObj = dataLayer.find(obj => obj.event === "zephr-pageview");

        switch ("{{analytics-rule-name}}") {
            case "verge-subscriptions":
                brandLetter = "I"
                break;
            case "vox-members-content":
                brandLetter = "H"
                break;
            default:
                brandLetter = "undefined";
            }

            return zephrObj
            ? Object.entries(zephrObj)
                .filter(([key]) => key.startsWith(brandLetter))
                .map(([key, value]) => \`\${key}\${value}\`)
                .join(",")
            : '';
    };

    const onSelect = (slot, href) => {
        dataLayer.push({
            event: "select_promotion",
            ecommerce: buildEcommerce(\`baby growl - \${slot}\`)
        });

        goTo(href, true);
    }

    const goTo = (href, hasAuthParams) => {
        const params = new URLSearchParams(location.search);

        if (hasAuthParams) {
            if ("{{itm_campaign}}") {
                params.set("itm_campaign", "{{itm_campaign}}");
            }

            if ("{{itm_medium}}") {
                params.set("itm_medium", "{{itm_medium}}");
            }

            if ("{{itm_source}}") {
                params.set("itm_source", "{{itm_source}}");
            }

            if (outcomeLabel) {
                params.set("outcome_label", outcomeLabel);
            }

    outcomeLabel
            if (experimentGroups) {
              params.set("experiment_groups", experimentGroups);
            }

            params.set("returnUrl", location.origin + location.pathname);
        }

        location.href = \`\${href}?\${params.toString()}\`;
    }

    // close button logic (growl timer, DL)
    const closeButton = document.getElementById("zephr-footer-close");
    if (closeButton) {
        closeButton.addEventListener("click", () => {
            const thirtyDays = 30 * 24 * 60 * 60; // days x hours x minutes x seconds
            document.cookie = \`growlCloseDate=\${Date.now()}; Max-Age=\${thirtyDays}; Path=/; SameSite=Strict; Secure\`;

            dataLayer.push({
                event: "select_promotion",
                ecommerce: buildEcommerce("baby growl - dismiss")
            });
        });
    }

    // add animation
    setTimeout(() => {
        const growlCloseDate = parseInt(document.cookie
                .split("; ")
                .find((row) => row.startsWith("growlCloseDate="))
                ?.split("=")[1]);
        if (!growlCloseDate) {
            const footer = document.querySelector("#zephr-zone-footer");
            const tout = document.querySelector("#zephr-footer-container");
            if (footer) footer.classList.add("transform");
            if (tout) {
              tout.classList.add("visible"); // visibility flag
              tout.setAttribute("data-wid", outcomeLabel);
            }
            tout.dispatchEvent(new CustomEvent("ToutImpression"));

            // Separate timeout bc Zephr's dataLayer is not reliably available until about 1s
            setTimeout(() => {
              dataLayer.push({
                  event: "view_promotion",
                  ecommerce: buildEcommerce()
              });
          }, 1000);
        }
    }, 1);
    </script>
    <script type="text/javascript">
      window.Zephr = window.Zephr || {};
      window.Zephr.includeOutcomes = true;
      window.Zephr.outcomesAsEvents = false;
      window.Zephr.groupFields = false;
    (function() {
        var xhr = new(XMLHttpRequest || ActiveXObject)('MSXML2.XMLHTTP.3.0');
        xhr.open('GET', '/blaize/datalayer', true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                var response;
                try {
                    response = JSON.parse(xhr.response);
                } catch (e) {
                    response = xhr.response;
                }
                if (xhr.status === 200) {
                    for (var dataLayerFieldName in response) {
                        if (!(dataLayerFieldName in window)) window[dataLayerFieldName] = [];

                        var pageView = response[dataLayerFieldName];
                        var events = [];

                        if (window.Zephr && window.Zephr.includeOutcomes && window.Zephr.outcomes) {
                            pageView.zephrOutcomes = window.Zephr.outcomes;

                            if (window.Zephr.outcomesAsEvents) {
                                Object.keys(window.Zephr.outcomes || []).forEach(function(outcomeKey) {
                                    var outcomeEvent = {
                                        event: "zephr-outcome-" + outcomeKey,
                                        featureId: outcomeKey,
                                        featureLabel: window.Zephr.outcomes[outcomeKey].featureLabel,
                                        outcomeId: window.Zephr.outcomes[outcomeKey].outcomeId,
                                        outcomeLabel: window.Zephr.outcomes[outcomeKey].outcomeLabel,
                                    };
                                    events.push(outcomeEvent);
                                });
                            }
                        }
                        if (window.Zephr && window.Zephr.accessDetails) {
                            Object.keys((window.Zephr.accessDetails.trials || {})).forEach(function(trialId){
                                var trial = window.Zephr.accessDetails.trials[trialId]
                                if(trial.reportInDataLayer){
                                    var usedCredits = trial.totalCredits - trial.remainingCredits
                                    if (window.Zephr.groupFields && !pageView.zephrTrials) pageView.zephrTrials = {};
                                    var target = window.Zephr.groupFields ? pageView.zephrTrials : pageView
                                    if (trial.dataLayerCreditsUsedKey) {
                                      target[trial.dataLayerCreditsUsedKey] = usedCredits;
                                    }
                                    if (trial.dataLayerCreditsRemainingKey) {
                                      target[trial.dataLayerCreditsRemainingKey] = trial.remainingCredits;
                                    }
                                }
                            });
                            (window.Zephr.accessDetails.trialTrackingDetails || []).forEach(function(details) {
                                var type = details.entitlementType === 'credits' ? 'credits' : 'meters';
                                var trial = (window.Zephr.accessDetails[type] || {})[details.entitlementId];
                                if (!trial) return;
                                if (window.Zephr.groupFields && !pageView.zephrTrials) pageView.zephrTrials = {};
                                if (details.creditsRemainingKey) {
                                    if (window.Zephr.groupFields) {
                                        pageView.zephrTrials[details.creditsRemainingKey] = trial.remainingCredits;
                                    } else {
                                        pageView[details.creditsRemainingKey] = trial.remainingCredits;
                                    }
                                }
                                if (details.creditsUsedKey) {
                                    if (window.Zephr.groupFields) {
                                        pageView.zephrTrials[details.creditsUsedKey] = trial.totalCredits - trial.remainingCredits;
                                    } else {
                                        pageView[details.creditsUsedKey] = trial.totalCredits - trial.remainingCredits;
                                    }
                                }
                            });
                            try {
                              (Object.keys(window.Zephr.accessDetails.timeTrials || {})).forEach(function(timeTrialId) {
                                  var timeTrial = window.Zephr.accessDetails.timeTrials[timeTrialId]
                                  if(timeTrial.reportInDataLayer){
                                      if (window.Zephr.groupFields && !pageView.zephrTrials) pageView.zephrTrials = {};
                                      var target = window.Zephr.groupFields ? pageView.zephrTrials : pageView

                                      if (timeTrial.dataLayerTrialDurationKey) {
                                        target[timeTrial.dataLayerTrialDurationKey] = timeTrial.trialDuration;
                                      }
                                      if (timeTrial.dataLayerTrialDurationUnitsKey) {
                                        target[timeTrial.dataLayerTrialDurationUnitsKey] = timeTrial.trialDurationUnits;
                                      }
                                      if (timeTrial.dataLayerTrackerEntryTimeKey) {
                                        target[timeTrial.dataLayerTrackerEntryTimeKey] = timeTrial.entryTime;
                                      }
                                      if (timeTrial.dataLayerTrackerHitsKey) {
                                        target[timeTrial.dataLayerTrackerHitsKey] = timeTrial.trackerHits;
                                      }
                                      if (timeTrial.dataLayerTrialTimeRemainingKey) {
                                        target[timeTrial.dataLayerTrialTimeRemainingKey] = timeTrial.timeRemainingInTrial;
                                      }
                                  }
                              });
                            } catch (err) {
                              console.error("Error aggregating Zephr time trials", err);
                            }
                        }
                        if (Object.keys(pageView).length) {
                            pageView.event = "zephr-pageview";
                            events.unshift(pageView);
                        }
                        if (!events.length) continue;

                        events.forEach(function(event) {
                            window[dataLayerFieldName].push(event);
                        });
                    }
                    var readyEvent = document.createEvent('Event');
                    readyEvent.initEvent('zephr.dataLayerReady', true, true);
                    document.dispatchEvent(readyEvent);
                }
            }
        }
        xhr.send({});
    })();
  </script>
`;
